import { render, staticRenderFns } from "./ModalTablePk10.vue?vue&type=template&id=508ac983&"
import script from "./ModalTablePk10.vue?vue&type=script&lang=js&"
export * from "./ModalTablePk10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports